// src/store/modules/cache.js
export default {
    namespaced: true,
    state: {
        cacheMap: {},
        navSource: null
    },
    mutations: {
        SET_NAV_SOURCE(state, source) {
            state.navSource = source
        },
        SET_CACHE(state, { name, value }) {
            state.cacheMap[name] = value
        }
    },
    getters: {
        isCached: state => name => !!state.cacheMap[name]
    }
}